import type { OutputFormat } from "../types";

export const formatLabels: Record<OutputFormat, string> = {
  jpeg: "JPEG",
  png: "PNG",
  webp: "WebP",
  avif: "AVIF",
  bmp: "BMP",
  tiff: "TIFF"
};

export const mimeByFormat: Record<OutputFormat, string> = {
  jpeg: "image/jpeg",
  png: "image/png",
  webp: "image/webp",
  avif: "image/avif",
  bmp: "image/bmp",
  tiff: "image/tiff"
};

export function extensionFor(format: OutputFormat) {
  return format === "jpeg" ? "jpg" : format;
}

export function usesQuality(format: OutputFormat) {
  return format === "jpeg" || format === "webp" || format === "avif";
}

export function preservesTransparency(format: OutputFormat) {
  return format === "png" || format === "webp" || format === "avif";
}

export function formatBytes(bytes: number) {
  if (!Number.isFinite(bytes)) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }

  return `${size.toFixed(size >= 10 || unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
}

export function replaceExtension(filename: string, format: OutputFormat, suffix: string) {
  const base = filename.replace(/\.[^.]+$/, "");
  return `${base}${suffix}.${extensionFor(format)}`;
}

export function savingsPercent(original: number, output: number) {
  if (!original || output >= original) return 0;
  return Math.round(((original - output) / original) * 100);
}
